import { useLanguage } from '../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-2">
      <button
        onClick={() => toggleLanguage('hu')}
        className={`w-8 h-8 rounded-full overflow-hidden border-2 transition-all ${
          language === 'hu' ? 'border-[#7B2F3D] scale-110' : 'border-gray-300 opacity-60 hover:opacity-100'
        }`}
        title="Magyar"
        aria-label="Switch to Hungarian"
      >
        <img 
          src="https://flagcdn.com/w80/hu.png" 
          alt="Hungarian" 
          className="w-full h-full object-cover"
        />
      </button>
      
      <button
        onClick={() => toggleLanguage('en')}
        className={`w-8 h-8 rounded-full overflow-hidden border-2 transition-all ${
          language === 'en' ? 'border-[#7B2F3D] scale-110' : 'border-gray-300 opacity-60 hover:opacity-100'
        }`}
        title="English"
        aria-label="Switch to English"
      >
        <img 
          src="https://flagcdn.com/w80/gb.png" 
          alt="English" 
          className="w-full h-full object-cover"
        />
      </button>
    </div>
  );
};

export default LanguageSwitcher;
